import { useState } from 'react';
import { hrApi } from '@/api';
import { DocumentTypeSelect, EmployeeSelect } from '@/components/selects';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { FileInput } from '@/components/ui/FileInput';
import { showApiError } from '@/utils/apiError';
import { RecordDataTable } from '@/components/ui/RecordDataTable';
import { notify } from '@/core/toast/notify';

export function HrDocumentsPage() {
  const [employeeId, setEmployeeId] = useState('');
  const [docs, setDocs] = useState<unknown[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [docTypeId, setDocTypeId] = useState('');

  const load = async () => {
    if (!employeeId) return;
    try {
      setDocs(await hrApi.listEmployeeDocuments(Number(employeeId)));
    } catch (err) {
      showApiError(err, 'Failed to load documents');
    }
  };

  const upload = async () => {
    if (!file || !employeeId || !docTypeId) {
      notify.error('Select employee, document type, and file');
      return;
    }
    try {
      await hrApi.uploadDocument(file, Number(employeeId), Number(docTypeId));
      notify.success('Document uploaded');
      load();
    } catch (err) {
      showApiError(err, 'Upload failed');
    }
  };

  return (
    <div>
      <PageHeader title="Employee documents" description="Upload and track document expiry" breadcrumbs={[{ label: 'HR', to: '/hr' }, { label: 'Documents' }]} />
      <section className="card mb-4 space-y-3 p-4">
        <EmployeeSelect value={employeeId} onChange={setEmployeeId} hrScoped />
        <Button variant="secondary" onClick={() => void load()}>Load documents</Button>
      </section>
      <section className="card space-y-3 p-4">
        <h3 className="font-semibold">Upload</h3>
        <DocumentTypeSelect value={docTypeId} onChange={setDocTypeId} required />
        <FileInput
          label="Document file"
          value={file}
          accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,image/*,application/pdf"
          placeholder="Choose a document to upload"
          onChange={(files) => setFile(files[0] ?? null)}
        />
        <Button onClick={() => void upload()}>Upload</Button>
        <RecordDataTable data={docs} embedded emptyTitle="No documents loaded" />
      </section>
    </div>
  );
}
